module.exports = __webpack_public_path__ + "static/media/EG.8ddf02a4.svg";